import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { FullDatePipe } from './full-date.pipe';
import Diff = moment.unitOfTime.Diff;

interface TimeRange {
  unit: Diff;
  range: number;
  transform: (diff: number) => string;
}

@Pipe({
  name: 'timestamp'
})
export class TimestampPipe implements PipeTransform {

  constructor(private translate: TranslateService){}

  private timeRanges: TimeRange[] = [
    { unit: 'milliseconds', range: 1000, transform: () => `Right now` },
    { unit: 'seconds', range: 60, transform: (diff) => `${diff} seconds ago` },
    { unit: 'minutes', range: 60, transform: (diff) => `${diff} minutes ago` },
    { unit: 'hours', range: 24, transform: (diff) => `${diff} hours ago` },
    { unit: 'days', range: 7, transform: (diff) => `${diff} days ago` }
  ];

  transform(timestamp: number, fullDate = false): any {
    if (!timestamp) {
      return null;
    }

    const date = moment(timestamp);
    const now  = moment();

    if (!fullDate) {
      for (const timeRange of this.timeRanges) {
        const diff = now.diff(date, timeRange.unit);
        if (diff > 0 && diff < timeRange.range) {
          return timeRange.transform(diff);
        }
      }
    }

    return new FullDatePipe(this.translate).transform(date);
  }

}
